/**
 * Base Schemas
 */

import { z } from 'zod';

export const emailSchema = z.email('validation.email.invalid');

export const phoneSchema = z
  .string()
  .regex(/^\+?[1-9]\d{1,14}$/, 'validation.phone.invalid')
  .optional();

export const urlSchema = z.url('validation.url.invalid');

export const dateStringSchema = z.iso.datetime();

export const timestampSchema = z.object({
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export const tenantScopedSchema = z.object({
  tenantId: z.uuid(),
});

export const auditableSchema = timestampSchema.extend({
  createdBy: z.uuid().optional(),
  updatedBy: z.uuid().optional(),
});

export const softDeleteSchema = z.object({
  deletedAt: z.coerce.date().nullable().optional(),
  deletedBy: z.uuid().nullable().optional(),
});

// File upload
export const fileUploadSchema = z.object({
  filename: z.string().min(1).max(255),
  mimeType: z.string(),
  size: z
    .number()
    .int()
    .positive()
    .max(100 * 1024 * 1024), // 100MB max
  url: z.url().optional(),
});

export type FileUpload = z.infer<typeof fileUploadSchema>;
